
import axios from 'axios'
import queryStringUtil from "query-string";

function queryString(query) {
    var queryParams = {
        page: query.page,
        pageSize: query.pageSize,
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function saveEvaluation(report) {
    return axios.put(`${process.env.VUE_APP_APIURL}/fault-reports/${report._id}/evaluation`, {
        questions: report.info.evaluation.questions.map(question => {
            return {
                code: question.question.code,
                answer: question.question.answer
            }
        })
    })
}

function getUnansweredEvaluationsCount() {

    const groupByKey = (list, key) => list.reduce((hash, obj) => ({ ...hash, [obj[key]]: (hash[obj[key]] || []).concat(obj) }), {})

    const user = JSON.parse(localStorage.getItem('user'))

    return axios.get(`${process.env.VUE_APP_APIURL}/fault-reports/unanswered-evaluations-count`)
        .then(resp => {
            const groupedData = groupByKey(resp.data.data.detectionReports, 'point')
            return Object.entries(groupedData).map(([key, value]) => ({ _id: key, point: key, unansweredEvaluationsCount: value.length }));
        })
}

function getVibrationAnalyzeReports(pointId, query) {
    const user = JSON.parse(localStorage.getItem('user'))
    return axios.get(`${process.env.VUE_APP_APIURL}/point/${pointId}/fault-reports`)
        .then(res => {
            return {
                total: res.data.data.total,
                reports: res.data.data.detectionReports.map(detectionReport => {
                    return {
                        _id: detectionReport.id,
                        isAnswered: detectionReport.isAnswered,
                        createdAt: detectionReport.createdAt,
                        customer: user.customerName,
                        customerId: detectionReport.customer,
                        partner: detectionReport.partner,
                        point: detectionReport.point,
                        faultType: detectionReport.detectionType,
                        name:detectionReport.name,
                        severity: detectionReport.severity,
                        pointPath: detectionReport.pointPath,
                        info: {
                            _id: detectionReport.code,
                            description: detectionReport.description,
                            evaluation: {
                                questions: detectionReport.questions.sort((a, b) => (a.order < b.order ? -1 : 1)),
                                isAnswered: detectionReport.isAnswered
                            },
                            suggestions: detectionReport.suggestions
                        },
                        image: detectionReport.image
                    };
                })
            }
        });
}

export default {
    getVibrationAnalyzeReports,
    getUnansweredEvaluationsCount,
    saveEvaluation,
};